import { PCType } from '@core/components/PageContext';

export function getTypeName(type: PCType) {
  switch (type) {
    case PCType.deal:
      return 'deal';
    case PCType.contact:
      return 'contact';
    case PCType.marketingBoard:
      return 'marketingBoard';
    case PCType.organization:
      return 'organization';
    case PCType.project:
      return 'project';
    case PCType.ticket:
      return 'ticket';
    default:
      return type;
  }
}
